var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "killer-question-specs" }, [
    _c(
      "div",
      [
        _vm._l(_vm.killerQuestionSpecs, function(killerQuestionSpec, i) {
          return _c(
            "fieldset",
            { key: i },
            [
              killerQuestionSpec.id
                ? _c("input", {
                    attrs: {
                      name: "killer_questions[" + i + "][id]",
                      type: "hidden",
                      required: ""
                    },
                    domProps: { value: killerQuestionSpec.id }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
                _c("div", { staticClass: "cell pl-10 ml-6 pr-0 small-12" }, [
                  _c("label", [_vm._v("Question(s)")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c("div", { staticClass: "cell auto pr-0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: killerQuestionSpec.title,
                            expression: "killerQuestionSpec.title"
                          }
                        ],
                        attrs: {
                          disabled: _vm.disabled,
                          name: "killer_questions[" + i + "][title]",
                          type: "text",
                          required: ""
                        },
                        domProps: { value: killerQuestionSpec.title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              killerQuestionSpec,
                              "title",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell shrink" }, [
                      !_vm.disabled
                        ? _c(
                            "div",
                            {
                              staticClass: "remove-button",
                              on: {
                                click: function() {
                                  return _vm.removeKillerQuestionSpec(i)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-minus-circle" })]
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0, true),
                _vm._v(" "),
                _vm._m(1, true)
              ]),
              _vm._v(" "),
              _vm._l(killerQuestionSpec.killer_question_answers, function(
                answer,
                j
              ) {
                return _c(
                  "div",
                  { key: j, staticClass: "grid-x grid-padding-x" },
                  [
                    answer.id
                      ? _c("input", {
                          attrs: {
                            name:
                              "killer_questions[" +
                              i +
                              "][killer_question_answers][" +
                              j +
                              "][id]",
                            type: "hidden",
                            required: ""
                          },
                          domProps: { value: answer.id }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell pl-30 pr-0 small-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: answer.title,
                            expression: "answer.title"
                          }
                        ],
                        attrs: {
                          disabled: _vm.disabled,
                          name:
                            "killer_questions[" +
                            i +
                            "][killer_question_answers][" +
                            j +
                            "][title]",
                          type: "text",
                          maxlength: "50",
                          required: ""
                        },
                        domProps: { value: answer.title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(answer, "title", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell pl-5 pr-0 auto" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: answer.is_correct,
                              expression: "answer.is_correct"
                            }
                          ],
                          attrs: {
                            disabled: _vm.disabled,
                            name:
                              "killer_questions[" +
                              i +
                              "][killer_question_answers][" +
                              j +
                              "][is_correct]",
                            required: ""
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                answer,
                                "is_correct",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: false } }, [
                            _vm._v("Fail")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: true } }, [
                            _vm._v("Pass")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell shrink" }, [
                      !_vm.disabled
                        ? _c(
                            "div",
                            {
                              staticClass: "remove-button",
                              on: {
                                click: function() {
                                  return _vm.removeAnswer(i, j)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-minus-circle" })]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              killerQuestionSpec.killer_question_answers.length == 0
                ? _c("input", {
                    attrs: {
                      disabled: _vm.disabled,
                      name:
                        "killer_questions[" + i + "][killer_question_answers]",
                      value: "",
                      type: "hidden"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.disabled
                ? _c(
                    "div",
                    {
                      staticClass: "add-button ml-20",
                      on: {
                        click: function($event) {
                          return _vm.addKillerQuestionSpecAnswer(i)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-plus-circle" })]
                  )
                : _vm._e()
            ],
            2
          )
        }),
        _vm._v(" "),
        !_vm.disabled
          ? _c(
              "div",
              {
                staticClass: "add-button",
                on: { click: _vm.addKillerQuestionSpec }
              },
              [_c("i", { staticClass: "fas fa-plus-circle" })]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.killerQuestionSpecs.length === 0
          ? _c("input", {
              attrs: { name: "killer_questions", value: "", type: "hidden" }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-30 pr-0 small-6" }, [
      _c("label", [_vm._v("Answer(s):")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-5 pr-0 small-6" }, [
      _c("label", [_vm._v("Result:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11a885a4", { render: render, staticRenderFns: staticRenderFns })
  }
}